export const RANGO_X_API_KEY = 'sndfje3u4b3fnNSDNFUSDNVSunw345842hrnfd3b4nt4';

export const RANGO_X_API_ENDPOINT = 'https://x-api.rubic.exchange/rango/basic';
